import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'decisionSupport',
    path: '/decision-support',
    component: () => import('../pages/DecisionSupportPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'decisionSupportDetails',
    path: '/decision-support/:decisionSupportId',
    component: () => import('../pages/DecisionSupportDetailsPage.vue'),
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'decisionSupportWizard',
    path: '/decisionSupport/wizard',
    component: () => import('../pages/DecisionSupportWizardPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'decisionSupportWizardCopy',
    path: '/decisionSupport/wizard/:decisionSupportId/copy',
    component: () => import('../pages/DecisionSupportWizardPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'decisionSupportWizardCopy',
    path: '/decisionSupport/wizard/:decisionSupportId/copy',
    component: () => import('../pages/DecisionSupportWizardPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
